module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../~/axios/index.js
// module id = 240
// module chunks = 0